module.exports = function(text, limit) {
  if (!text) return '...';
  const maxLength = limit - 3;
  if (text.length <= maxLength) return text;
  return `${text.substr(0, maxLength)}...`;
};
